import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { skip, take } from 'rxjs/operators';
import { AuthenticationService } from '../authentication.service';
import { UserCredentialsStore } from '../user-credentials-store.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  private redirectUrl: string;

  constructor(
    protected authenticationService: AuthenticationService,
    protected userCredentialsStore: UserCredentialsStore,
    protected router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    if (this.authenticationService.isLoggedIn()) {
      return of(true);
    }

    if (this.router.navigated) {
      return this.authenticationService.layerLogin();
    } else {
      this.redirectUrl = state.url;
      this.router.navigate(['/user/login'], { replaceUrl: true, skipLocationChange: true });

      this.userCredentialsStore.userCredentials$.pipe(skip(1), take(1)).subscribe(userCredentials => {
        if (userCredentials) {
          if (this.redirectUrl) {
            this.router.navigateByUrl(this.redirectUrl);
            this.redirectUrl = null;
          }
        }
      });

      return of(false);
    }
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.canActivate(route, state);
  }
}
